import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timedisplay'
})
export class TimedisplayPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    //return null;
    var hh = Math.floor(value / 3600), mm = Math.floor(value / 60) % 60, ss = Math.floor(value) % 60;
    return hh + ":" + (mm < 10 ? "0" : "") + mm + ":" + (ss < 10 ? "0" : "") + ss;
  }

}



// WEBPACK FOOTER //
// /Users/aubreyfletcher/Desktop/projects/node/node_projects/ng5/cashfletcher_videoPlayer/src/app/timedisplay.pipe.ts